module.exports = __webpack_public_path__ + "static/img/logo01.fd114adb.png";